<div *ngIf="sector" class="simple-travel-summary-item-container" [class.inside-card]="insideCard"
  [class.user-history-cont]="isUserHistory"
  [class.booking-cont]="isBookingProvider"
  [class.package-resume]="isPackageResumeProvider">
  <div class="travel-info">
    <div class="table">
      <app-ds-flight-scale-table
        [size]="flightScaleTableSize"
        [airlineLogo]="sector.AirlineCode | airlineImage"
        [airlineName]="sector.AirlineName"
        [departurePointCode]="sector.DepartureAirport"
        [arrivalPointCode]="sector.ArrivalAirport"
        [departureTime]="sector.DepartureDate | date: 'HH:mm'"
        [arrivalTime]="sector.ArrivalDate | date: 'HH:mm'"
        [daysDifference]="sector.ArrivalDate | arrivalDays: sector.DepartureDate"
        [flightTime]="sector.TotalDuration |timeFormat: 2"
        [baggage]="{
          CheckedBaggage: includesLuggageWarehouse(sector.Flights[0].BaggageRestrictions | luggage),
          CabinbBaggage: sector.Flights[0].HandBaggage,
          PersonalItem: !disableBackpackLuggage(sector.Flights[0].AirlineCode),
        }"
        [stops]="scalesNumber(sector)"
        [stopsLabel]="scalesText(sector) | transloco: { quantity: scalesNumber(sector) }"
        (clickEvent)="openDetailByCard()">
      </app-ds-flight-scale-table>
    </div>
    <div class="row-action" *ngIf="openDetailIsEnabled" (click)="openDetail()">
      <app-ds-icon
        [icon]="iconChevronRight"
        [size]="16">
      </app-ds-icon>
    </div>
  </div>
</div>
